export enum ShopStatus {
    New = 0,
    Approved = 1,
    Paused = 2,
    Deleted = 3
}

type ShopContactsType = {
    phone: string
    address: string
    website: string
    email: string
}

type ProductType = {
    userId: number
    rating: number
    comment: string
    product: { id: number, title: string }[]
}

export type ShopTypes = {
    city: string
    country: string
    id: number
    title: string
    allWorldDelivery: boolean
    description: string
    shortDescription: string
    image: string //base64string
    contacts: ShopContactsType
    status: ShopStatus
    ratingSum: 18
    salesCount: 8
    products: ProductType[]
}

export type ResponseType<T> = {
    resultCode: ResultCodesEnum
    messages: string[]
    data: T
}

export enum ResultCodesEnum {
    Success = 0,
    Error = 1
}

export type CouponType = {
    customerFeedback: string
    customerShopRating: number
    id: number
    lastStatusChangeDate: string
    productTitle: string
    shopId: number
    customerName: string
    userId: number
}

export const CORE_BASE_URL = 'https://staging3.beatmaker.tv'


